
export default {
    name: "MobileFooter",
    data: () => ({}),
};
